import { useTranslation } from "react-i18next";

function LayersEmpty() {
  const { t } = useTranslation();

  return <div className="text-center text-sm">{t("layers_empty")}</div>;
}

export default LayersEmpty;
